import API from "api/axiosInstance";
import {
  setIsLoading,
  setListNotifikasi,
  setListPanduan,
  setMessage,
  setStatus,
} from "./index";

export const fetchListPanduan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/panduan/get");
    dispatch(setIsLoading(false));
    dispatch(setListPanduan(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddPanduan = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const formData = new FormData();
    formData.append("nama_sop", reqData.nama_sop);
    formData.append("file_sop", reqData.file_sop);

    const response = await API.post("/panduan/add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error?.response?.data?.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchEditPanduan = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/panduan/edit_panduan", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};
export const fetchDeletePanduan = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/panduan/delete/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
